import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeleteButton from '../../common/components/DeleteButton';
import { withTranslation } from 'react-i18next';

class ChildDeleteButton extends Component {
    render() {
        const { t, onDelete, child } = this.props;
        return (
            <DeleteButton onDelete={() => onDelete(child)}
                confirmationTitle={t('FO_Child_ConfirmDeleteTitle')}
                confirmationMessage={t('FO_Child_ConfirmDeleteMessage', { name: child.fullName })} />
        );
    }
}

ChildDeleteButton.propTypes = {
    onDelete: PropTypes.func,
    child: PropTypes.shape({
        id: PropTypes.number,
        fullName: PropTypes.string,
    })
};

export default withTranslation()(ChildDeleteButton);